import { createFileRoute, redirect } from '@tanstack/react-router';
import { FUNDING_TRANSFER_BASE_PATH } from '../../../../features/funding/transfer/funding-transfer-routing';

export const Route = createFileRoute('/_app/_clearing-core/funding/')({
  beforeLoad: () => {
    throw redirect({ to: FUNDING_TRANSFER_BASE_PATH });
  },
  preload: false,
});
